import React, { useState, useEffect } from 'react';
import './Hero.css';
import image1 from '../assets/images/meeting.jpg';
import image2 from '../assets/images/1.jpeg';
import image3 from '../assets/images/3.jpeg';

const Hero = () => {
  const [stats, setStats] = useState({
    clients: 0,
    leads: 0,
    satisfaction: 0
  });

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [image1, image2, image3];

  // Auto-slide images every 5 seconds
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);

    return () => clearInterval(slideInterval);
  }, [images.length]);

  // Animate stats on mount
  useEffect(() => {
    const animateStats = () => {
      const duration = 2000;
      const targets = { clients: 500, leads: 10000, satisfaction: 98 };
      const steps = 60;
      const increment = duration / steps;

      let step = 0;
      const timer = setInterval(() => {
        step++;
        setStats({
          clients: Math.min(Math.floor((targets.clients / steps) * step), targets.clients),
          leads: Math.min(Math.floor((targets.leads / steps) * step), targets.leads),
          satisfaction: Math.min(Math.floor((targets.satisfaction / steps) * step), targets.satisfaction)
        });

        if (step >= steps) clearInterval(timer);
      }, increment);
    };

    animateStats();
  }, []);

  const scrollToContact = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="hero" id="home">
      {/* Sliding Background Images */}
      <div className="hero-slider">
        {images.map((image, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentImageIndex ? 'active' : ''}`}
            style={{ backgroundImage: `url(${image})` }}
          ></div>
        ))}
      </div>
      
      <div className="hero-overlay"></div>
      
      {/* Stats in Left Corner */}
      <div className="hero-stats-corner">
        <div className="corner-stat-item">
          <h3 className="corner-stat-number">{stats.clients}+</h3>
          <p className="corner-stat-label">Happy Clients</p>
        </div>
        <div className="corner-stat-item">
          <h3 className="corner-stat-number">{stats.leads}+</h3>
          <p className="corner-stat-label">Leads Generated</p>
        </div>
        <div className="corner-stat-item">
          <h3 className="corner-stat-number">{stats.satisfaction}%</h3>
          <p className="corner-stat-label">Satisfaction Rate</p>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          {/* Center Content - Text */}
          <div className="hero-center">
            <div className="hero-box">
              <h1 className="hero-title">
                Your Trusted Partner for Candidate Sourcing, Lead Generation (B2B & B2C), Recruitment Support & Virtual Assistance
              </h1>
              <p className="hero-description">
                Scalable sourcing and lead generation services tailored to elevate your business's growth and efficiency across the globe.
              </p>
              <button className="btn btn-primary hero-button" onClick={scrollToContact}>
                Get Started
              </button>
            </div>
          </div>
        </div>

        {/* Slider Indicators */}
        <div className="slider-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;